export { ComponentError } from './component-error';
